// src/api/client.js
// import axios from "axios";

// const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

// export const api = axios.create({
//   baseURL: BASE,
// });

// // attach JWT + language automatically
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   const lang = localStorage.getItem("lang") || "en";
//   if (!config.headers) config.headers = {};
//   config.headers["Accept-Language"] = lang;
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // Optional: handle demo read-only + auth issues globally
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     const { status, data } = err.response || {};
//     if (status === 401) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("isDemo");
//       if (typeof window !== "undefined") window.location.href = "/login";
//     } else if (status === 403 && data?.error === "DEMO_READ_ONLY") {
//       alert("Demo mode: create/update/delete actions are disabled.");
//     }
//     return Promise.reject(err);
//   }
// );

// src/api/client.js// src/api/client.js
import axios from "axios";

const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export const api = axios.create({
  baseURL: BASE,
  timeout: 30000,
});

// ---- Demo helpers (unchanged) ----
export const isDemoActive = () => localStorage.getItem("isDemo") === "1";
export const setDemoActive = (active, reason) => {
  if (active) {
    localStorage.setItem("isDemo", "1");
    if (reason) localStorage.setItem("demoReason", reason);
  } else {
    localStorage.removeItem("isDemo");
    localStorage.removeItem("demoReason");
  }
};
export const getDemoReason = () => localStorage.getItem("demoReason") || "";

// Use this only if your UI lets the user switch stores for /internal routes
export const setTenantHeader = (storeId) => {
  const sid = storeId ? String(storeId) : null;
  if (sid) localStorage.setItem("storeId", sid);
  else localStorage.removeItem("storeId");
};

// -------------- REQUEST INTERCEPTOR (single) --------------
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");           // read fresh on every request
  const lang  = localStorage.getItem("lang") || "en";
  const storeId = localStorage.getItem("storeId");       // optional, only for /internal

  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["Accept-Language"] = lang;
  config.headers["Cache-Control"]   = "no-store";

  // Attach X-Store-Id **only** for /internal calls; never leak it to /api
  const fullUrl = `${config.baseURL || ""}${config.url || ""}`;
  if (/\/internal\b/.test(fullUrl)) {
    if (storeId) config.headers["X-Store-Id"] = storeId;
  } else {
    delete config.headers["X-Store-Id"];
  }

  return config;
});

// -------------- RESPONSE INTERCEPTOR (single) --------------
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status, data } = err.response || {};
    const message = data?.message || "";

    if (status === 401) {
      // clear auth + caches on sign-out
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      setDemoActive(false);
      if ("caches" in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
      window.location.replace("/login");
    } else if (status === 403) {
      if (data?.error === "DEMO_READ_ONLY") {
        alert("Demo mode: create/update/delete actions are disabled.");
      }
      const noStore =
        /no\s*storeid\s*on\s*user/i.test(message) ||
        /no\s*store\s*on\s*user/i.test(message);
      if (noStore) setDemoActive(true, message);
    }
    return Promise.reject(err);
  }
);
